var modernBrowser = ('fetch' in window &&
    'assign' in Object);
// Polyfills
if (!modernBrowser) {
    var polyfillScript = document.createElement('script');
    polyfillScript.async = false;
    polyfillScript.src = "/dist/js/polyfills.js";
    document.head.appendChild(polyfillScript);
}
import Vue from 'vue';
// The Rest.
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
// Third Party ES6 Libraries
import SweetScroll from 'sweet-scroll';
import { VueMaskDirective } from 'v-mask';
import VueCookies from 'vue-cookies';
import LazyLoad from "vanilla-lazyload";
// Custom Components
import AddressChecker from './components/address-checker.vue';
import Advisories from './components/advisories.vue';
import AnimatedTitle from './components/animated-title.vue';
import InternationalCallRates from './components/international-call-rates.vue';
import JoinSkymesh from './components/join-skymesh.vue';
import Modal from './components/modal.vue';
import PlanSelector from './components/plan-selector.vue';
import PlanCard from './components/plans/plan-card.vue';
import SimActivator from './components/sim-activator.vue';
import SubMenu from './components/sub-menu.vue';
import SupportSearch from './components/support-search.vue';
import PlanComparison from './components/plan-comparison-table/plan-comparison-table.vue';
import { Shuffle } from './shuffle';
import { DropdownMenu } from './dropdown-menu';
import './product-carousel';
import './contactMap';
import './tablepress';
import { Carousel } from './carousel';
import { forEach } from 'lodash-es';
import { NfGoogleTracking } from './nf-google-tracking';
Vue.use(VueCookies);
Vue.directive('mask', VueMaskDirective);
window.addEventListener('DOMContentLoaded', function () {
    window.lazyLoader = new LazyLoad({
        elements_selector: ".lazy"
    });
});
var MODAL_TYPE_ORDER = 'ORDER';
var MODAL_TYPE_EXPLAINED = 'EXPLAINED';
new Vue({
    components: {
        AddressChecker: AddressChecker,
        Advisories: Advisories,
        AnimatedTitle: AnimatedTitle,
        InternationalCallRates: InternationalCallRates,
        Modal: Modal,
        PlanComparison: PlanComparison,
        PlanSelector: PlanSelector,
        PlanCard: PlanCard,
        SimActivator: SimActivator,
        SupportSearch: SupportSearch,
        SubMenu: SubMenu,
        JoinSkymesh: JoinSkymesh
    },
    el: "#app",
    data: function () {
        return {
            addressID: -1,
            confirmedTechnology: '',
            showMakeOrderModal: false,
            selectedPlan: {},
            modalType: MODAL_TYPE_ORDER,
        };
    },
    created: function () {
        this.addressID = parseInt(this.$cookies.get('addressId'));
        var ls = localStorage.getItem('skyTechnology');
        if (ls) {
            var data = JSON.parse(ls);
            this.confirmedTechnology = data.qualification.technology;
        }
    },
    methods: {
        onAddressChange: function (newAddressID) {
            this.addressID = newAddressID;
        },
        onTechnologyChange: function (newTechnology) {
            this.confirmedTechnology = newTechnology;
        },
        onShowOrderModal: function (plan, modalType) {
            if (modalType === void 0) { modalType = MODAL_TYPE_ORDER; }
            this.showMakeOrderModal = true;
            this.selectedPlan = plan;
            this.modalType = modalType;
            // @ts-ignore
            var planSubmit = plan.details.normal_quota || plan.details.normal_quota.price;
            this.$nextTick(function () {
                typeof jQuery !== 'undefined' && jQuery(".__plan-selector input[name='__plan-selector']").val(planSubmit).trigger('change');
            });
        },
        onShowShapingExplainedModal: function (plan, modalType) {
            if (modalType === void 0) { modalType = MODAL_TYPE_EXPLAINED; }
            this.showMakeOrderModal = true;
            this.selectedPlan = plan;
            this.modalType = modalType;
        },
        onCloseOrderModal: function () {
            this.showMakeOrderModal = false;
        },
    },
});
var scroller = new SweetScroll({
    trigger: "a[href^='#']:not([href='#'])"
});
document.addEventListener('DOMContentLoaded', function () {
    var hash = window.location.hash;
    var hasHashOnLoad = document.getElementById(hash.substr(1)) != null;
    if (hasHashOnLoad) {
        window.location.hash = '';
    }
    window.addEventListener('load', function () {
        if (hasHashOnLoad) {
            scroller.to(hash, { updateURL: 'replace' });
        }
    }, false);
}, false);
var shuffle = new Shuffle();
var tabsElement = document.querySelector('.tab-blocks__wrapper');
if (tabsElement) {
    // set the 'all' tab to be clicked by default.
    shuffle.initializeRefs().then(function (cats) {
        return cats.forEach(function (cat) {
            if (cat.category === 'all')
                cat.$ref.click();
        });
    });
}
new DropdownMenu('[data-hover-toggle]');
new Carousel('[data-carousel]');
new NfGoogleTracking();
document.addEventListener('DOMContentLoaded', function () {
    var invalidClassName = 'invalid';
    forEach(document.querySelectorAll('input, select, textarea'), function (input) {
        input.addEventListener('invalid', function () {
            input.classList.add(invalidClassName);
        });
        input.addEventListener('input', function () {
            if (input.validity.valid) {
                input.classList.remove(invalidClassName);
            }
        });
    });
});
